"use strict";import{ButtonBase as t}from"./ButtonBase.js";export class StyledButton extends t{}
//# sourceMappingURL=StyledButton.js.map
